const FLOW_SEPARATOR = ',';

/**
 * Parses a `flow="flowName,flowName"` style string (used by the Facebook Ad
 * Sets grid to store multiple flows on a single row) into individual flow
 * names, trimming whitespace and dropping empty entries. Also accepts the
 * legacy `"flowName, flowName"` form with a space after the comma.
 */
export const parseFlowsString = (value: string | null | undefined): string[] => {
  if (!value) {
    return [];
  }

  return value
    .split(',')
    .map((name) => name.trim())
    .filter((name) => name.length > 0);
};

/** Joins individual flow names with `,` and no following space. */
export const stringifyFlows = (flows: string[]): string => flows.join(FLOW_SEPARATOR);

/** Canonical `flowA,flowB` form, or undefined when there are no names. */
export const normalizeFlowsString = (
  value: string | null | undefined,
): string | undefined => {
  const names = parseFlowsString(value);
  return names.length ? stringifyFlows(names) : undefined;
};
